import React, { Component } from "react";
import { Container, Row, Col, Table, Form, Badge, Card } from "react-bootstrap";
import CommonRowId from "../components/CommonRowId";
import { OptionsConstants } from '../../config/constants/OptionsConstants';
import { formatNumber } from '../../library/utilitys';

class DataTableDashboardSecATrainee extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    render = () => {

        let props = this.props;

        let { data, title, icon, bg = 'primary', column } = props;
        let { loading } = this.state;
        const monthShort = OptionsConstants.variables.months.th.fn;
        
        return (
            <Card className="card-border mb-5">
                <Card.Header className={`card-header-action bg-${bg}`}>
                    <h6 className="text-white">{icon && <i className={`${icon} me-2`}></i>}{title}</h6>
                </Card.Header>
                <Card.Body style={{ maxHeight: '350px', position: 'relative', overflowY: 'auto' }}>
                    <Row>
                        <Col md={12}>
                            <Table
                                responsive
                                // borderless
                                className={`table-advance table-visible`}
                            >
                                <thead >
                                    <tr>
                                        <th className="th-td-align-center th-width-50p">เดือน</th>
                                        <th className="th-td-align-left th-width-200p">ชื่ออุตสาหกรรม</th>
                                        <th className="th-td-align-center th-width-150p">ผู้ผ่านการอบรม</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.rows.map((row, index) => (
                                        <React.Fragment key={index}>
                                            <tr className={((index % 2) === 1) ? 'striped-row' : ''}>                                             

                                                <td className="text-end text-center">
                                                    {row.months != data.rows[index - 1]?.months ? monthShort[Number(row.months) - 1] : ''}
                                                </td>

                                                <td className="text-truncate" title={row.target_industries_name || '-'}>
                                                    {row.target_industries_name}
                                                </td>

                                                <td className="text-end text-center" title={row.person_amount}>
                                                    {formatNumber(row.person_amount) + " คน" || '-'}
                                                </td>
                                            </tr>

                                            <tr className="table-row-gap">
                                                <td colSpan={6} />
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </Table>

                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
}

export default DataTableDashboardSecATrainee;